import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-vec-border bg-white py-5"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center whitespace-nowrap">
                {items.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-display text-lg sm:text-xl font-medium uppercase tracking-wide text-vec-charcoal/85 px-6">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-vec-green/70" />
                    </span>
                ))}
            </div>
        </div>
    );
};
